import React, {useState, useEffect} from "react";
import PropTypes from "prop-types";
import Select, { components } from "react-select";
import {enterFocus} from "../utils";
import _ from 'lodash';

function Select2(props) {
  const {
    options,
    name,
    className,
    classNamePrefix,
    placeholder,
    onChange,
    value,
    ariaInvalid,
    isClearable,
    maxLength,
    isDisabled,
    hasError = false,
    heightSelect,
    widthMenu,
    nextFocus = '',
    ...rest
  } = props;
  const [v, setV] = useState(value);
  const [isFocus, setIsFocus] = useState(false);
  useEffect(() => {
    setV(value);
  }, [value]);
  var selectStyles = className
    ? className + (ariaInvalid ? " invalid" : "")
    : "";
  var borderColor = hasError ? "#F85955" : "#9E9E9E";
  var backgroundColor = isDisabled === true ? "bg-gray-200" : isFocus ? "bg-yellow-100" : "bg-white";
  var defaultHeight = (window.innerWidth < 1280) ? '38px' : '40px';
  var heightStyles = heightSelect ? heightSelect : defaultHeight;
  var widthMenuStyles = widthMenu ? widthMenu : "100%";
  let maxH = 48
  if (options) {
    if (options.length > 4) {
      maxH = 4 * maxH;
    } else {
      maxH = options.length === 0 ? maxH : options.length * maxH;
    }
  }

  const style = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      minHeight: heightStyles,
      borderColor: borderColor,
      backgroundColor: backgroundColor,
      borderRadius: "6px",
      padding: "0",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#9E9E9E",
      },
      "&:focus": {
        backgroundColor: "yellow"
      },
    }),
    option: (optionStyles, { isFocused }) => ({
      ...optionStyles,
      backgroundColor: isFocused ? "#F3F4F6" : "white",
      color: "#212121",
      whiteSpace: "nowrap"
    }),
    input: (base) => ({
      ...base,
      "input:focus": {
        padding: "0",
        margin: "0",
        boxShadow: "none",
      },
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    menu: (provided, state) => ({
      ...provided,
      width: widthMenuStyles,
    }),
    menuList: (provided) => ({
      ...provided,
      // maxHeight: "20vh",
      maxHeight: `${maxH}px`,
      overflowY: "auto",
    }),
    placeholder: (base) => ({
      ...base,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    })
  };
  const NoOptionsMessage = (props) => {
    return (
      <components.NoOptionsMessage {...props}>
        <span>オプションなし</span>
      </components.NoOptionsMessage>
    );
  };

  const handleFocus = (e) => {
    setIsFocus(true);
  }

  const handleBlur = (e) => {
    setIsFocus(false);
  }

  const handleKeyDown = (e) => {
    if (nextFocus && e.key === 'Enter') {
      return enterFocus(nextFocus);
    }
  }

  const [inputValue, setInputValue] = useState('');
  const handleChangeInput = (value) => {
    if (!maxLength || value.length <= maxLength) {
      setInputValue(value);
    }
  }

  return (
    <Select
      components={{
        IndicatorSeparator: () => null,
        NoOptionsMessage,
      }}
      onInputChange={handleChangeInput}
      inputValue={inputValue}
      className={`lg:h-10 h-[38px] rounded-[6px] lg:text-base text-[15px] ${selectStyles} ${backgroundColor}`}
      classNamePrefix={classNamePrefix}
      inputId={`${name}_id`}
      name={name}
      value={v}
      menuPortalTarget={document.body}
      isClearable={isClearable}
      styles={style}
      onChange={(e) => {onChange(e); setIsFocus(false)}}
      options={options}
      placeholder={placeholder}
      aria-invalid={ariaInvalid}
      isDisabled={isDisabled}
      onFocus={(e) => handleFocus(e)}
      onBlur={(e) => handleBlur(e)}
      onKeyDown={(e) => handleKeyDown(e)}
      {...rest}
    />
  );
}

export default Select2;

Select2.propTypes = {
  options: PropTypes.array,
  name: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
};
